import apiClient from './apiClient';
import { COMMON_ENDPOINTS } from '../constants/apiEndpoints';
import { ENV } from '../config/env.config';
import { IAppAssetsResponse, ICommonConstantsResponse } from '../type/common-type';

let cachedConstants: ICommonConstantsResponse | null = null;
let constantsPromise: Promise<ICommonConstantsResponse> | null = null;
let cachedAppAssets: IAppAssetsResponse | null = null;
let appAssetsPromise: Promise<IAppAssetsResponse> | null = null;

const resolveAppAssetUrl = (url: string | null | undefined): string | null => {
	if (!url) return null;
	try {
		const apiOrigin = new URL(ENV.API_BASE_URL, window.location.origin).origin;
		return new URL(url, `${apiOrigin}/`).toString();
	} catch {
		return url;
	}
};

export const commonService = {
	// GET COMMON CONSTANTS (CACHED IN-MEMORY TO PREVENT REDUNDANT NETWORK CALLS)
	getConstants: async (force = false): Promise<ICommonConstantsResponse> => {
		if (!force && cachedConstants) {
			return cachedConstants;
		}

		if (!force && constantsPromise) {
			return constantsPromise;
		}

		constantsPromise = (async () => {
			try {
				const response = await apiClient<ICommonConstantsResponse>(COMMON_ENDPOINTS.CONSTANTS);
				cachedConstants = response;
				return response;
			} finally {
				constantsPromise = null;
			}
		})();

		return constantsPromise;
	},
	getAppAssets: async (): Promise<IAppAssetsResponse> => {
		if (cachedAppAssets) return cachedAppAssets;
		if (appAssetsPromise) return appAssetsPromise;

		appAssetsPromise = (async () => {
			try {
				const response = await apiClient<IAppAssetsResponse>(COMMON_ENDPOINTS.APP_ASSETS);
				cachedAppAssets = response;
				return response;
			} finally {
				appAssetsPromise = null;
			}
		})();

		return appAssetsPromise;
	},
	getAppAssetUrl: async (icon: string): Promise<string | null> => {
		const response = await commonService.getAppAssets();
		const asset = response.data?.find((entry) => entry.icon === icon);
		return resolveAppAssetUrl(asset?.url);
	},

	clearCache: () => {
		cachedConstants = null;
		constantsPromise = null;
		cachedAppAssets = null;
		appAssetsPromise = null;
	},
};

export default commonService;

